import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Profile from '../../../models/Profile';

export type ProfileState = {
  /** Unused */
  loadingProfile: boolean;
  profile: Profile;

  /** Actually used */
  currentRole: string;
  currentLicense: string;
  lastLoginErrorMessage: string;
};

export const initialState: ProfileState = {
  loadingProfile: false,
  profile: {
    IdUser: '',
    Name: '',
    LastName: '',
    State: '',
    Profile: '',
    Email: '',
    Telephone: '',
  },
  currentRole: '',
  currentLicense: '',
  lastLoginErrorMessage: '',
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    overwriteProfile: (
      _,
      action: PayloadAction<ProfileState>,
    ): ProfileState => {
      return action.payload;
    },
    requestProfile: (state): void => {
      state.loadingProfile = true;
    },
    requestProfileSuccess: (state, action: PayloadAction<Profile>): void => {
      state.loadingProfile = false;
      state.profile = action.payload;
    },
    requestProfileFailure: (state): void => {
      state.loadingProfile = false;
    },
    setCurrentRole: (state, action: PayloadAction<string>): void => {
      state.currentRole = action.payload;
    },
    setSessionEmail: (state, action: PayloadAction<string>): void => {
      state.profile.Email = action.payload;
    },
    setLastLoginErrorMessage: (state, action: PayloadAction<string>): void => {
      state.lastLoginErrorMessage = action.payload;
    },
    setCurrentLicense: (state, action: PayloadAction<string>): void => {
      state.currentLicense = action.payload;
    },
    setProfileIdUser: (state, action: PayloadAction<string>): void => {
      state.profile.IdUser = action.payload;
    },
    setProfileName: (state, action: PayloadAction<string>): void => {
      state.profile.Name = action.payload;
    },
  },
});

export const {
  overwriteProfile,
  requestProfile,
  requestProfileSuccess,
  requestProfileFailure,
  setCurrentRole,
  setLastLoginErrorMessage,
  setSessionEmail,
  setCurrentLicense,
  setProfileIdUser,
  setProfileName,
} = profileSlice.actions;

export default profileSlice.reducer;
